import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Cheque from "./Cheque";
import Document from "./Document";
import GridConfig from "./GridConfig";

export default class Cheques extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'cheque',
            type: props.Type,
            data: null,
            loading: true,
            configName: 'cheques_grid',
            moduleName: 'چکها',
            filters: {
                type: props.Type
            }
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    componentWillReceiveProps(props) {
        if (props.Type == this.state.filters.type) return;
        this.state.filters.type = props.Type;
        this.refreshData();
    }
    change(id, status) {
        this.removeKeyDown();
        this.showComponents({ component: <Cheque Type={this.state.type} Caller={this} Id={id} Status={status} /> });
    }
    showDocument(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Document Type={this.state.type} Caller={this} Id={id} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "number", caption: "شماره چک", show: true },
                { field: "price", caption: "مبلغ", show: true },
                { field: "chequeDateString", caption: "تاریخ", show: true },
                { field: "personName", caption: (this.state.filters.type === 1 ? "دریافت از" : "پرداخت به"), show: true },
                { field: "bankName", caption: "بانک", show: true },
                { field: "branch", caption: "شعبه", show: true },
                { field: "statusString", caption: "وضعیت", show: false },
                { field: "toBankDateString", caption: "تاریخ واگذاری", show: false },
                { field: "vosolDateString", caption: "تاریخ وصول", show: false },
                { field: "returnDateString", caption: "تاریخ عودت", show: false },
                { field: "returnDescription", caption: "شرح عودت", show: false },
                { field: "editDateString", caption: "تاریخ ثبت", show: false },
                { field: "createDateString", caption: "تاریخ بروزرسانی", show: false }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'number' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.number}</a> } });
            if (f.field == 'price' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number' });
            if (f.field == 'dateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'personName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'bankName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'branch' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'statusString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'note' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'toBankDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'vosolDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'returnDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'returnDescription' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });

        if (this.state.filters.type === 1) {
            t.push({
                field: "id",filter:false, headerName: "", cellRenderer: (props) => {
                    return [                        
                        <a className="text-primary txt-bold hand" onClick={e => this.change(props.data.id,2)}>واگذاری</a>
                        ,
                        <a className="text-primary txt-bold hand" onClick={e => this.change(props.data.id, 5)}>عودت</a>
                    ]
                }
            });
        }
        if (this.state.filters.type === 2) {
            t.push({ field: "id", headerName: "", cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.change(props.data.id, 5)}> عودت</a> } });
        }
        
        return t;
    }
    renderForm() {
        return <div className="container">
            {this.getToolBar(false, { add: false, print: true, pdf: true, excell: true,remove:false,otherFilters:null })}
            {this.renderAgGrid({
                columnDefs: this.getColumns()
            })}
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                this.renderForm(),
                this.renderPopupComponent(),
                <Footer />
            ];
        return contents;
    }
}